import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0cd796f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "card wrapper" };
const _hoisted_2 = { class: "label" };
const _hoisted_3 = {
    key: 0,
    class: "valueRow"
};
const _hoisted_4 = { class: "value" };
const _hoisted_5 = {
    key: 0,
    class: "deltaWrapper"
};
const _hoisted_6 = {
    key: 0,
    class: "deltaDown"
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", {
    class: "fas fa-arrow-down",
    "aria-hidden": "true"
}, null, -1));
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = {
    key: 1,
    class: "deltaUp"
};
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", {
    class: "fas fa-arrow-up",
    "aria-hidden": "true"
}, null, -1));
const _hoisted_11 = [
    _hoisted_10
];
const _hoisted_12 = {
    key: 2,
    class: "deltaEqual"
};
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", {
    class: "fas fa-equals",
    "aria-hidden": "true"
}, null, -1));
const _hoisted_14 = [
    _hoisted_13
];
const _hoisted_15 = {
    key: 3,
    class: "deltaValue"
};
const _hoisted_16 = {
    key: 4,
    class: "deltaPercent"
};
const _hoisted_17 = {
    key: 1,
    class: "valueRow"
};
export default /*#__PURE__*/ _defineComponent({
    __name: 'MetricSummaryCard',
    props: {
        label: {},
        metric: {},
        prefixUnit: {},
        suffixUnit: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1),
                (_ctx.metric)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.prefixUnit ? _ctx.prefixUnit : '') + _toDisplayString(_ctx.metric.current) + _toDisplayString(_ctx.suffixUnit ? _ctx.suffixUnit : ''), 1),
                        (_ctx.metric.previous)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                (_ctx.metric.previous > _ctx.metric.current)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _hoisted_8))
                                    : _createCommentVNode("", true),
                                (_ctx.metric.previous < _ctx.metric.current)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_11))
                                    : _createCommentVNode("", true),
                                (_ctx.metric.previous == _ctx.metric.current)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _hoisted_14))
                                    : _createCommentVNode("", true),
                                (_ctx.metric.previous != _ctx.metric.current)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.prefixUnit ? _ctx.prefixUnit : '') + _toDisplayString(Math.abs(_ctx.metric.current - _ctx.metric.previous)) + _toDisplayString(_ctx.suffixUnit ? _ctx.suffixUnit : ''), 1))
                                    : _createCommentVNode("", true),
                                (_ctx.metric.previous != _ctx.metric.current && _ctx.metric.previous != 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "(" + _toDisplayString(Math.round(100 * Math.abs(_ctx.metric.current - _ctx.metric.previous) / _ctx.metric.previous)) + "%)", 1))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, "No Data"))
            ]));
        };
    }
});
